import { render } from "./MDetails.vue?vue&type=template&id=0fa4bf58&scoped=true"
import script from "./MDetails.vue?vue&type=script&lang=js"
export * from "./MDetails.vue?vue&type=script&lang=js"

import "./MDetails.vue?vue&type=style&index=0&id=0fa4bf58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa4bf58"]])

export default __exports__